import { render, staticRenderFns } from "./MetodoPago.vue?vue&type=template&id=2567e61e&scoped=true"
import script from "./MetodoPago.vue?vue&type=script&lang=ts"
export * from "./MetodoPago.vue?vue&type=script&lang=ts"
import style0 from "./MetodoPago.vue?vue&type=style&index=0&id=2567e61e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2567e61e",
  null
  
)

export default component.exports